import { Component, Input } from '@angular/core';
import { faChevronRight, faHome } from '@fortawesome/free-solid-svg-icons';

export interface Breadcrumb {
  name: string;
  pretty_url: string;
  isHome?: boolean;
  queryParamsHandling?: string;
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
  public readonly faChevronRight = faChevronRight;
  public readonly faHome = faHome;

  @Input() public breadcrumbs: Breadcrumb[];

  private home: Breadcrumb = {
    name: 'GO_TO_HOME',
    pretty_url: '',
    isHome: true,
  };

  public get breadcrumbsWithHome() {
    return [this.home, ...this.breadcrumbs];
  }
}
